<script>
import ViewHeader from '@/components/ViewHeader.vue';
import { useMetersStore } from '@/stores/meters.ts';
import { useCredentialsStore } from '@/stores/credentials.js';

export default {
  name: 'SettingsView',
  components: { ViewHeader },
  data() {
    return {
      meterStore: useMetersStore(),
    };
  },
  methods: {
    logOut() {
      // Remove theme
      const companyId =
        useMetersStore().getMeterDetails.plant.owning_company_id;
      document.documentElement.classList.remove('theme-' + companyId);

      useCredentialsStore().clear();
      this.meterStore.clearAll();

      this.$router.push({ name: 'sign-in' });
    },
  },
  computed: {
    subtitle() {
      if (!this.meterDetails) {
        return '';
      }

      return (
        this.meterDetails.plant.address.street +
        ' ' +
        this.meterDetails.plant.address.house_number +
        ', ' +
        this.meterDetails.plant.address.city
      );
    },
    meterDetails() {
      return this.meterStore.getMeterDetails;
    },
    formattedOperationalSince() {
      let formatter = new Intl.DateTimeFormat('nl-NL', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      });
      return formatter.format(new Date(this.meterDetails.operational_since));
    },
    textExplainer() {
      return (
        'Dit dashboard laat de opbrengst van jouw zonnepanelen zien.' +
        " De gegevens worden 's nachts bijgewerkt." +
        ' Met jouw zonnepanelen wek je 100% groene energie op.' +
        ' Daarom hoeft er geen kolen of gas verstookt te worden.' +
        ' Hoeveel impact dat heeft zie je bij de CO2 besparing.' +
        ` De besparing in euro’s wordt berekend met een gemiddelde elektriciteitsprijs van ${this.meterDetails.amount_in_cents_per_kwh} cent.`
      );
    },
  },
};
</script>

<template>
  <div>
    <view-header title="Profiel" :sub-title="subtitle"/>
    <br/>
    <div v-if="meterDetails" class="px-7">
      <div class="section-header">Zonnepanelen</div>
      Wattpiek: {{ meterDetails.peak_in_watt }} Wp<br/>
      Operationeel vanaf: {{ formattedOperationalSince }}<br/>

      <divider/>

      <div class="section-header">Over dit dashboard</div>
      <div>{{ textExplainer }}</div>

      <hr/>
      <br/>

      <Button @click="logOut" class="button">
        <span>Uitloggen</span>
        <font-awesome-icon icon="fa-arrow-right-from-bracket" class="icon" />
      </Button>

      <RouterLink :to="{ name: 'sign-in' }" @click="logOut" class="nav-link">
      </RouterLink>
    </div>
  </div>
</template>

<style scoped>
.section-header {
  @apply text-xl font-bold;
}

.button {
  @apply text-slate-700;
  border-radius: 19px;
  border: 0;
  box-sizing: border-box;
}

.icon {
  @apply fill-slate-700 ;
  font-size: 1.5rem;
  width: 1rem;
  height: 1rem;
}
</style>
